import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface INotHappenedPayload extends ISagaCb {
    meetingId: string
    data: {
        reason: string
        rate: number
    }
}

export interface INotHappenedState {
    status: string
    data: any
    errors: any
}

const initialState: INotHappenedState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const notHappened = createSlice({
    name: 'momentum/not-happened',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<INotHappenedPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const notHappenedActions = notHappened.actions
export default notHappened.reducer
